import { render, staticRenderFns } from "./courseGoodsDetail.vue?vue&type=template&id=42bbd35f&scoped=true&"
import script from "./courseGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./courseGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./courseGoodsDetail.vue?vue&type=style&index=0&id=42bbd35f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bbd35f",
  null
  
)

export default component.exports